import { useParams } from 'react-router'
import { isClientCode } from './modifier'

/**
 * Параметр пути профиля клиента: `/clients/:client/…`. Имя совпадает с модификатором `client`
 * ручек — код из пути уходит в API так же, как раньше `?client=`.
 */
export const CLIENT_ROUTE_PARAM = 'client'

/** Вкладки профиля клиента — вложенные адреса `/clients/:client/<вкладка>`. */
export type ClientProfileTab =
  | 'orders'
  | 'shipments'
  | 'settlements'
  | 'reports'
  | 'stats'
  | 'carts'
  | 'catalog'
  | 'order-catalog'
  | 'pc-build'

/** Адрес профиля клиента или его вкладки. Без вкладки — обзор. */
export function clientProfilePath(code: string, tab?: ClientProfileTab): string {
  const base = `/clients/${encodeURIComponent(code)}`
  return tab === undefined ? base : `${base}/${tab}`
}

/**
 * Клиент из пути профиля (`/clients/:client/…`). Вне профиля — `undefined`. Кривой код
 * отбрасывается по формату бэка, как и в строке запроса.
 */
export function useRouteClient(): string | undefined {
  const value = useParams()[CLIENT_ROUTE_PARAM]
  return isClientCode(value) ? value : undefined
}
